// uploads.js

import { buy } from '../actions';

const initialState = {
  main_url: '',
  thumb_url_1: '',
  thumb_url_2: '',
  thumb_url_3: '',
  all_received: false,
  status: buy.types.READY
};

const buy_reducers = (state = initialState, action) => {
  let newstate = {};
  switch (action.type) {
    case buy.types.READY:
      return { ...state, ...initialState };

    case buy.types.BUYING:
      return { ...state, status: action.type };

    case buy.types.MAINURLRECEIVED:
      newstate = {
        status: action.type,
        main_url: action.main_url
      };
      return { ...state, ...newstate };

    case buy.types.GOTSIZE1:
      newstate = {
        status: action.type,
        thumb_url_1: action.thumb_url_1
      };
      return { ...state, ...newstate };

    case buy.types.GOTSIZE2:
      newstate = {
        status: action.type,
        thumb_url_2: action.thumb_url_2
      };
      return { ...state, ...newstate };

    case buy.types.GOTSIZE3:
      newstate = {
        status: action.type,
        thumb_url_3: action.thumb_url_3
      };
      return { ...state, ...newstate };

    case buy.types.COMPLETE:
      return { ...state, status: action.type };

    default:
      return state;
  }
};

export default buy_reducers;



// WEBPACK FOOTER //
// ./src/store/reducers/buy.js